import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'awhr43',
  Description: 'Here\'s all the online content included with your <strong>WJEC English Literature Poetry Guide</strong>.',
  Credits: 'Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2025.  All rights reserved.\n'
};
